export default __webpack_public_path__ + "static/media/close-grey.5d363a74.svg";